import ExperimentDashboardInfoPanel from 'components/commandpanel/ExperimentDashboardInfo/ExperimentDashboardInfoPanel';
import ImageTools from 'components/commandpanel/ExperimentPanel/ExperimentTools/ImageTools';
import RMCustomButton from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';
import { RMSvgIconNames } from 'components/customComponents/CommonComponents/RMSvgIcon';
import { ITabItem, useTabs } from 'components/tab';
import React, {
  Dispatch,
  SetStateAction,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react';

export interface useSlideShowPanelsProps {
  selectedTab: string | number;
  setSelectedTab: Dispatch<SetStateAction<number>>;
  isButtonsDisabled: boolean;
}

const getTabSelector = (iconName: RMSvgIconNames) => {
  return (
    <RMCustomButton
      iconProps={{ name: iconName }}
      mainContainerClass="w-[28px] h-[32px] border-solid border-[#CACACA] border-[1px] border-radius rounded-r-lg"
    />
  );
};
const useSlideShowPanels = (props: useSlideShowPanelsProps) => {
  const { selectedTab, setSelectedTab, isButtonsDisabled } = props;
  const [selectedDisplayIndex, setSelectedDisplayIndex] = useState(selectedTab);

  const onTabSelectionChange = useCallback(
    (value) => {
      setSelectedTab(value);
      setSelectedDisplayIndex(value);
    },
    [selectedTab],
  );

  useEffect(() => {
    setSelectedDisplayIndex(selectedTab);
  }, [selectedTab]);

  const tabItems_: ITabItem[] = useMemo(() => {
    return [
      {
        id:'slideshowpanels-tabitems-imagetools',
        customTabSelectionItem: getTabSelector('ImageTools'),
        content: selectedTab === 'tools' && <ImageTools />,
        externalKey: 'tools',
      },
      {
        id:'slideshowpanels-tabitems-info',
        customTabSelectionItem: getTabSelector('Info'),
        content: selectedTab === 'info' && <ExperimentDashboardInfoPanel />,
        externalKey: 'info',
      },
    ];
  }, [selectedTab]);

  const [tabSelectors, , selectedPanel] = useTabs(
    tabItems_,
    selectedDisplayIndex,
    onTabSelectionChange,
    isButtonsDisabled,
    true,
  );

  return [tabSelectors, selectedPanel as React.ReactNode];
};

export default useSlideShowPanels;
